(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozd-404"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.add('ozd-service-page-active');document.body.classList.add('ozd-service-active');
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozd-contact-page"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.add('ozd-service-page-active');document.body.classList.add('ozd-service-active');document.addEventListener('shopify:section:unload',function(event){if(event.target&&event.target.querySelector('[data-ozd-contact-page]')){document.documentElement.classList.remove('ozd-service-page-active');document.body.classList.remove('ozd-service-active');}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozd-service-page"] && !Shopify.designMode) return;
  try {
    
  document.documentElement.classList.add('ozd-service-page-active');
  document.body.classList.add('ozd-service-active');
  document.addEventListener('shopify:section:unload', function(event) {
    if (event.target && event.target.querySelector('[data-ozd-service-page]')) {
      document.documentElement.classList.remove('ozd-service-page-active');
      document.body.classList.remove('ozd-service-active');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ozd-studio-page"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.add('ozd-service-page-active');document.body.classList.add('ozd-service-active');document.addEventListener('shopify:section:unload',function(event){if(event.target&&event.target.querySelector('[data-ozd-studio-page]')){document.documentElement.classList.remove('ozd-service-page-active');document.body.classList.remove('ozd-service-active');}});
  } catch(e) { console.error(e); }
})();
})();
